var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pro-card',[_c('div',{staticStyle:{"text-align":"center","opacity":"0.3"}},[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":require("../assets/img/logo_cor.svg"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }